(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderVideo {
    atTop = true;
    playing = false;
    prefersReducedMotion = false;

    init() {
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handleScroll();

      const video = this.$refs.video;
      if (video) {
        // Sync state with actual video state
        this.playing = !video.paused;

        // Listen for play/pause events to stay in sync
        video.addEventListener('play', () => (this.playing = true));
        video.addEventListener('pause', () => (this.playing = false));

        if (this.prefersReducedMotion) {
          video.pause();
        }
      }

      window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    }

    handleScroll() {
      this.atTop = window.scrollY < 50;
    }

    toggle() {
      const video = this.$refs.video;
      if (!video) return;

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('headerVideo', () => new HeaderVideo());
  });

  } catch(e) { console.error(e); }
})();
})();
